import { Fragment, h } from "preact";
import { useSelector } from "react-redux";
import { getValue, renderHtml } from "../../helpers";

import i18n from "../../i18n";
import { getVariable } from "../../services/config";
import { selectCurrentUser } from "../../store";

import Button from "../Button.jsx";
import ListItem from "../ListItem.jsx";
import ProfileLink from "../ProfileLink.jsx";
import WhitepaperTeaser from "../WhitepaperTeaser.jsx";

export default {
  pre_assessment_result: ({ answers, onNext, onRestart, ...props }) => {
    const iscoNumbers = getVariable("technicalTalentPoolISCOs");
    // FIXME: The same as requirement :is_for_talentpool
    const supportedOccupation =
      iscoNumbers.indexOf(getValue(answers.occupation)) !== -1 ||
      ["developers", "designers", "product_managers", "others"].indexOf(
        getValue(answers.areaOfWork)
      ) !== -1;

    const i18nPrefix = supportedOccupation
      ? "products.pre_assessment.supported"
      : "products.pre_assessment.unsupported";

    return (
      <section class="task-page">
        <h1 class="task-page__headline">{i18n.t(`${i18nPrefix}.title`)}</h1>
        <p class="t-body3 mb-48">
          {renderHtml(i18n.t(`${i18nPrefix}.description`))}
        </p>
        {supportedOccupation ? (
          <Fragment>
            <ListItem number={1}>{i18n.t(`${i18nPrefix}.item_one`)}</ListItem>
            <ListItem number={2}>{i18n.t(`${i18nPrefix}.item_two`)}</ListItem>
            <ListItem number={3}>{i18n.t(`${i18nPrefix}.item_three`)}</ListItem>
            <ListItem number={4}>{i18n.t(`${i18nPrefix}.item_four`)}</ListItem>
          </Fragment>
        ) : (
          <Fragment></Fragment>
        )}
        <WhitepaperTeaser
          class="mt-48 mb-48"
          title="Guide to Germany"
          description={i18n.t("whitepaperTeaser.guideToGermany")}
          whitepaperId="guide-to-germany"
        />
        <ProfileLink bordered />

        <p class="t-body3 mt-64">{i18n.t(`${i18nPrefix}.next_steps`)}</p>
        <div class="task-page__buttons mt-64">
          <Button onClick={onNext}>{i18n.t("actions.done")}</Button>

          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
};
